import { render, staticRenderFns } from "./InventoryRecord.vue?vue&type=template&id=1216bc74&scoped=true"
import script from "./InventoryRecord.vue?vue&type=script&lang=js"
export * from "./InventoryRecord.vue?vue&type=script&lang=js"
import style0 from "./InventoryRecord.vue?vue&type=style&index=0&id=1216bc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216bc74",
  null
  
)

export default component.exports